import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    initialDaypartingCardCheckedData,
    initialDaypartingDataObject,
    ISubModules,
} from "@ts/constants";
import {
    CA_DD_MODULES,
    Campaign,
    IConfirmModalState,
    IDailyBudgetResponse,
    IResponse,
    IRevstackPopupData,
    Keyword,
    RevstackCASectionIds,
    RevstackDashboardModules,
    Rule,
    TCommonRowData,
    TGoal,
    TGoalDataValues,
    TMediaPlanConfig,
    TRuleModuleAction,
    TTrendSeries,
} from "@ts/common-types";
import { GridApi } from "ag-grid-community";
import { updateDailyBudgetConfig } from "@/ts/retrieve-data";

const warningsModalSlice = createSlice({
    name: "warningsModalDisp",
    initialState: { value: false },
    reducers: {
        updateWarningsModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const customModalSlice = createSlice({
    name: "customModalDisp",
    initialState: { value: false },
    reducers: {
        updateCustomModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const bulkActionModalSlice = createSlice({
    name: "bulkActionModalDisp",
    initialState: { value: false },
    reducers: {
        updateBulkActionModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const addToExactModalDispSlice = createSlice({
    name: "addToExactModalDisp",
    initialState: { value: false },
    reducers: {
        updateAddToExactModalDisp: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const createCampaignModalSlice = createSlice({
    name: "createCampaignModalDisp",
    initialState: { value: false },
    reducers: {
        updateCreateCampaignModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const actionModalSlice = createSlice({
    name: "actionModalDisp",
    initialState: { value: false },
    reducers: {
        updateActionModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const trendsModalSlice = createSlice({
    name: "trendsModalDisp",
    initialState: { value: false },
    reducers: {
        updateTrendsModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const customModalTitleSlice = createSlice({
    name: "customModalTitle",
    initialState: { value: "" },
    reducers: {
        updateCustomModalTitle: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const bulkKeywordMappingModalSlice = createSlice({
    name: "bulkKeywordMappingModalDisplay",
    initialState: { value: false },
    reducers: {
        setBulkKeywordMappingModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const keywordModalTypeSlice = createSlice({
    name: "keywordModalType",
    initialState: { value: "" },
    reducers: {
        updateKeywordModalType: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const productModalTypeSlice = createSlice({
    name: "productModalType",
    initialState: { value: "" },
    reducers: {
        updateProductModalType: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const trendsTitleSlice = createSlice({
    name: "trendsTitle",
    initialState: { value: "" },
    reducers: {
        updateTrendsTitle: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const trendsDataOneSlice = createSlice({
    name: "trendsDataOne",
    initialState: { value: {} },
    reducers: {
        updateTrendsDataOne: (state, action: PayloadAction<TTrendSeries>) => {
            state.value = action.payload;
        },
    },
});

const trendsDataTwoSlice = createSlice({
    name: "trendsDataTwo",
    initialState: { value: {} },
    reducers: {
        updateTrendsDataTwo: (state, action: PayloadAction<TTrendSeries>) => {
            state.value = action.payload;
        },
    },
});

const asinIdSlice = createSlice({
    name: "asinId",
    initialState: { value: "" },
    reducers: {
        updateAsinId: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const keywordsSlice = createSlice({
    name: "keywords",
    initialState: { value: [] },
    reducers: {
        updateKeywords: (state, action: PayloadAction<TCommonRowData>) => {
            state.value = action.payload;
        },
    },
});

const smartKeywordsSlice = createSlice({
    name: "smartKeywords",
    initialState: { value: [] },
    reducers: {
        updateSmartKeywords: (
            state,
            action: PayloadAction<number[]>
        ) => {
            state.value = action.payload;
        }
    }
});

const searchTermCampaignsSlice = createSlice({
    name: "searchTermCampaigns",
    initialState: { value: [] },
    reducers: {
        updateSearchTermCampaigns: (
            state,
            action: PayloadAction<number[]>
        ) => {
            state.value = action.payload;
        }
    }
});

const submoduleElementSlice = createSlice({
    name: "submoduleElement",
    initialState: { value: [] },
    reducers: {
        updateSubmoduleElement: (
            state,
            action: PayloadAction<Array<ISubModules | []>>
        ) => {
            state.value = action.payload;
        },
    },
});

const moduleActionSlice = createSlice({
    name: "moduleAction",
    initialState: { value: [] },
    reducers: {
        updateModuleAction: (
            state,
            action: PayloadAction<TRuleModuleAction>
        ) => {
            state.value = action.payload;
        },
    },
});

const isEditSlice = createSlice({
    name: "isEdit",
    initialState: { value: false },
    reducers: {
        updateIsEdit: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const isRuleSaveButtonDisabledSlice = createSlice({
    name: "isRuleSaveButtonDisabled",
    initialState: { value: false },
    reducers: {
        setIsRuleSaveButtonDisabled: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});
const isDaypartingEditSlice = createSlice({
    name: "isDaypartingEdit",
    initialState: { value: false },
    reducers: {
        updateIsDaypartingEdit: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const isAllPortfoliosSelectedSlice = createSlice({
    name: "isAllPortfoliosSelected",
    initialState: { value: false },
    reducers: {
        updateIsAllPortfoliosSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const isAllCampaignsSelectedSlice = createSlice({
    name: "isAllCampaignsSelected",
    initialState: { value: false },
    reducers: {
        updateIsAllCampaignsSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const isAllAdgroupsSelectedSlice = createSlice({
    name: "isAllAdgroupsSelected",
    initialState: { value: false },
    reducers: {
        updateIsAllAdgroupsSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const isAllPfmDataSelectedSlice = createSlice({
    name: "isAllPfmDataSelected",
    initialState: { value: false },
    reducers: {
        updateIsAllPfmDataSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const daypartingEditCampaignDataSlice = createSlice({
    name: "daypartingEditCampaignData",
    initialState: { value: [] },
    reducers: {
        updateDaypartingEditCampaignData: (
            state,
            action: PayloadAction<string[]>
        ) => {
            state.value = action.payload;
        },
    },
});

const daypartingDataObjectSlice = createSlice({
    name: "daypartingDataObject",
    initialState: { value: initialDaypartingDataObject },
    reducers: {
        updateDaypartingDataObject: (
            state,
            action: PayloadAction<Record<string, Array<number>>>
        ) => {
            state.value = action.payload;
        },
    },
});

const daypartingCardCheckedDataSlice = createSlice({
    name: "daypartingCardCheckedData",
    initialState: { value: initialDaypartingCardCheckedData },
    reducers: {
        updateDaypartingCardCheckedData: (
            state,
            action: PayloadAction<Record<string, object>>
        ) => {
            state.value = action.payload;
        },
    },
});

const bulkTaxonomyDisplaySlice = createSlice({
    name: "bulkTaxonomyDisplay",
    initialState: { value: false },
    reducers: {
        updateBulkTaxonomyDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const updateBidOrBudgetModalSlice = createSlice({
    name: "updateBidOrBudgetModalDisplay",
    initialState: {
        value: false,
        type: 'bid' as 'bid' | 'budget'
    },
    reducers: {
        updateBidOrBudgetModalDisplay: (state, action: PayloadAction<{ value: boolean; type: 'bid' | 'budget' }>) => {
            state.value = action.payload.value;
            state.type = action.payload.type;
        },
    },
});

const dailyBudgetModalDisplaySlice = createSlice({
    name: "dailyBudgetModalDisplay",
    initialState: { value: false },
    reducers: {
        updateDailyBudgetModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const bulkPlacementModalDisplaySlice = createSlice({
    name: "bulkPlacementModalDisplay",
    initialState: { value: false },
    reducers: {
        updateBulkPlacementModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const dailyBudgetModalDataSlice = createSlice({
    name: "dailyBudgetModalData",
    initialState: { value: {} },
    reducers: {
        updateDailyBudgetModalData: (state, action: PayloadAction<Campaign>) => {
            state.value = action.payload;
        },
    },
});

const dailyBudgetReviewModalDisplaySlice = createSlice({
    name: "dailyBudgetReviewModalDisplay",
    initialState: { value: false },
    reducers: {
        updateDailyBudgetReviewModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const dailyBudgetUpdatePayloadeSlice = createSlice({
    name: "dailyBudgetUpdatePayload",
    initialState: { value: {} },
    reducers: {
        updateDailyBudgetUpdatePayload: (state, action: PayloadAction<IResponse>) => {
            state.value = action.payload;
        },
    },
});

const dailyBudgetUpdateResponseSlice = createSlice({
    name: 'dailyBudgetUpdateResponse',
    initialState: {
        value: {},
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            updateDailyBudgetConfig.pending,
            (state: IDailyBudgetResponse) => {
                state.isLoading = true;
            });
        builder.addCase(
            updateDailyBudgetConfig.fulfilled,
            (state: IDailyBudgetResponse, action) => {
                state.isLoading = false;
                state.value = action.payload;
            });
        builder.addCase(
            updateDailyBudgetConfig.rejected,
            (state: IDailyBudgetResponse, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

const showAdminSettingsDisplaySlice = createSlice({
    name: "showAdminSettingsDisplay",
    initialState: { value: false },
    reducers: {
        updateShowAdminSettingsDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});


const showCreateKeywordsReviewDisplaySlice = createSlice({
    name: "showCreateKeywordsReviewDisplay",
    initialState: { value: false },
    reducers: {
        updateShowCreateKeywordsReviewDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        }
    }
})

const dayPartingDisplaySlice = createSlice({
    name: "dayPartingDisplay",
    initialState: { value: false },
    reducers: {
        updateDayPartingDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const ruleSlice = createSlice({
    name: "rule",
    initialState: { value: {} },
    reducers: {
        updateRule: (state, action: PayloadAction<Rule | object>) => {
            state.value = action.payload;
        },
    },
});

const rulesApiSlice = createSlice({
    name: "rulesApiSlice",
    initialState: { value: {} },
    reducers: {
        updateRulesApi: (state, action: PayloadAction<GridApi>) => {
            state.value = action.payload;
        },
    },
});

const isSessionExpiredSlice = createSlice({
    name: "isSessionExpired",
    initialState: { value: true },
    reducers: {
        updateIsSessionExpired: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const showRequestAlertSlice = createSlice({
    name: "showRequestAlert",
    initialState: { value: false },
    reducers: {
        updateShowRequestAlert: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const overwriteRequestSlice = createSlice({
    name: "overwriteRequest",
    initialState: { value: false },
    reducers: {
        updateOverwriteRequest: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const addAsExactDataSlice = createSlice({
    name: "addAsExactData",
    initialState: { value: [] },
    reducers: {
        setAddAsExactData: (state, action: PayloadAction<Keyword[]>) => {
            state.value = action.payload;
        }
    }

});

const campaignPortfolioDataSlice = createSlice({
    name: "campaignPortfolioData",
    initialState: { value: [] },
    reducers: {
        setcampaignPortfolioData: (state, action: PayloadAction<Campaign[]>) => {
            state.value = action.payload;
        }
    }
});

const isSearchTermExactSlice = createSlice({
    name: "isSearchTermExact",
    initialState: { value: false },
    reducers: {
        setIsSearchTermExact: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    }
});

const addToAdgroupModalDataSlice = createSlice({
    name: "addToAdgroupModalData",
    initialState: { value: {}, display: false },
    reducers: {
        updateAddToAdgroupModalData: (state, action: PayloadAction<GridApi>) => {
            state.value = action.payload;
        },
        updateAddToAdgroupModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.display = action.payload;
        },
    },
});

const campaignConfigModalDisplaySlice = createSlice({
    name: "campaignConfigModalDisplay",
    initialState: { value: false },
    reducers: {
        updateCampaignConfigModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const isCampaignStateActionSlice = createSlice({
    name: "isCampaignStateAction",
    initialState: { value: false },
    reducers: {
        updateIsCampaignStateAction: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const campaignStateActionResponseSlice = createSlice({
    name: "campaignStateActionResponse",
    initialState: { value: {} },
    reducers: {
        updateCampaignStateActionResponse: (
            state,
            action: PayloadAction<Record<string, any>>
        ) => {
            state.value = action.payload;
        },
    },
});

const cpmModalDisplaySlice = createSlice({
    name: "updateCpmModalDisplay",
    initialState: { value: false },
    reducers: {
        updateCpmModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const addGoalsModalDisplaySlice = createSlice({
    name: "addGoalsModalDisplay",
    initialState: { value: false },
    reducers: {
        updateAddGoalsModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const deepDiveModalSlice = createSlice({
    name: "deepDiveModalDisplay",
    initialState: { value: false },
    reducers: {
        updateDeepDiveModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const goalDataValuesSlice = createSlice({
    name: "goalDataValues",
    initialState: { value: {} },
    reducers: {
        setGoalDataValues: (
            state,
            action: PayloadAction<TGoalDataValues>
        ) => {
            state.value = action.payload;
        },
    },
});

const goalEditConfigSlice = createSlice({
    name: "goalEditConfig",
    initialState: { value: {} },
    reducers: {
        setGoalEditConfig: (
            state,
            action: PayloadAction<TGoal>
        ) => {
            state.value = action.payload;
        },
    },
});

const goalModalTitleSlice = createSlice({
    name: "goalModalTitle",
    initialState: { value: "" },
    reducers: {
        setGoalModalTitle: (
            state,
            action: PayloadAction<string>
        ) => {
            state.value = action.payload;
        },
    },
});

const isGoalFormSubmittedSlice = createSlice({
    name: "isGoalFormSubmitted",
    initialState: { value: false },
    reducers: {
        setIsGoalFormSubmitted: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const goalListStatusTypeSlice = createSlice({
    name: "goalListStatusType",
    initialState: { value: "active" },
    reducers: {
        setGoalListStatusType: (
            state,
            action: PayloadAction<string>
        ) => {
            state.value = action.payload;
        },
    },
});

const addBulkTagsModalDisplaySlice = createSlice({
    name: "addBulkTagsModalDisplay",
    initialState: { value: false },
    reducers: {
        setAddBulkTagsModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const bulkProductMappingModalDisplaySlice = createSlice({
    name: "bulkProductMappingModalDisplay",
    initialState: { value: false },
    reducers: {
        setBulkProductMappingModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const biddingModalSlice = createSlice({
    name: "biddingModal",
    initialState: {
        value: {
            display: false,
            data: null
        }
    },
    reducers: {
        updateBiddingModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value.display = action.payload;
        },
        updateBiddingModalData: (
            state,
            action: PayloadAction<Record<string, string | number>>
        ) => {
            state.value.data = action.payload;
        },
    },
});

const addMediaPlanModalDisplaySlice = createSlice({
    name: "addMediaPlanModalDisplay",
    initialState: { value: false },
    reducers: {
        updateAddMediaPlanModalDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const showNewMediaPlanDisplaySlice = createSlice({
    name: "showNewMediaPlanDisplay",
    initialState: { value: false },
    reducers: {
        updateShowNewMediaPlanDisplay: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    }
});

const mediaPlanConfigValuesSlice = createSlice({
    name: "mediaPlanConfigValues",
    initialState: { value: {} },
    reducers: {
        setMediaPlanConfigValues: (
            state,
            action: PayloadAction<TMediaPlanConfig>
        ) => {
            state.value = action.payload;
        },
    }
});

const productMappingFilterModelSlice = createSlice({
    name: "productMappingFilterModel",
    initialState: { value: {} },
    reducers: {
        updateProductMappingFilterModel: (
            state,
            action: PayloadAction<Record<string, any>>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordMappingFilterModelSlice = createSlice({
    name: "keywordMappingFilterModel",
    initialState: { value: {} },
    reducers: {
        updateKeywordMappingFilterModel: (
            state,
            action: PayloadAction<Record<string, any>>
        ) => {
            state.value = action.payload;
        },
    },
});

const bulkPfmMappingCountSlice = createSlice({
    name: "bulkPfmMappingCount",
    initialState: { value: 0 },
    reducers: {
        updateBulkPfmMappingCount: (state, action: PayloadAction<number>) => {
            state.value = action.payload;
        },
    },
});

const bulkKeywordMappingCountSlice = createSlice({
    name: "bulkKeywordMappingCount",
    initialState: { value: 0 },
    reducers: {
        updateBulkKeywordMappingCount: (state, action: PayloadAction<number>) => {
            state.value = action.payload;
        },
    },
});

const apply1DsMappingModalDisplaySlice = createSlice({
    name: "apply1DsMappingModalDisplay",
    initialState: { value: false },
    reducers: {
        updateApply1DsMappingModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const apply1DsKeywordMappingModalDisplaySlice = createSlice({
    name: "apply1DsKeywordMappingModalDisplay",
    initialState: { value: false },
    reducers: {
        updateApply1DsKeywordMappingModalDisplay: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const confirmModalDisplaySlice = createSlice({
    name: "confirmModalDisplay",
    initialState: { value: false, title: "", message: "", onConfirm: null },
    reducers: {
        updateConfirmModalDisplay: (state, action: PayloadAction<IConfirmModalState>) => {
            state.value = action.payload.value;
            state.title = action.payload.title;
            state.message = action.payload.message;
            state.onConfirm = action.payload.onConfirm;
        },
    },
});

const showRevstackPopupSlice = createSlice({
    name: "showRevstackPopup",
    initialState: {
        value: {
            drilldown: {
                title: "",
                show: false,
                activeSectionId: null,
                module: null,
            },
            trends: {
                show: false,
                activeSectionId: null,
                module: null,
                defaultTab: null,
                hideTrendsTabSection: false,
                titlePills: [],
            },
            changeSku: {
                show: false,
                activeSectionId: null,
                module: null,
                defaultTab: null,
                hideTrendsTabSection: false,
                titlePills: [],
                selectedChangeSku: null as number | null,
            }
        }
    },
    reducers: {
        updateDrilldownState: (state, action: PayloadAction<IRevstackPopupData['drilldown']>) => {
            state.value.drilldown.show = action.payload.show;
            state.value.drilldown.title = action.payload.title;
            state.value.drilldown.activeSectionId = action.payload.activeSectionId;
            state.value.drilldown.module = action.payload.module;
        },
        updateTrendsState: (state, action: PayloadAction<IRevstackPopupData['trends']>) => {
            state.value.trends.show = action.payload.show;
            state.value.trends.activeSectionId = action.payload.activeSectionId;
            state.value.trends.module = action.payload.module;
            state.value.trends.defaultTab = action.payload.defaultTab;
            state.value.trends.hideTrendsTabSection = action.payload.hideTrendsTabSection;
            state.value.trends.titlePills = action.payload.titlePills;
        },
        updateChangeSkuState: (state, action: PayloadAction<IRevstackPopupData['changeSku']>) => {
            state.value.changeSku.show = action.payload.show;
        },
        updateSelectedChangeSku: (state, action: PayloadAction<number>) => {
            state.value.changeSku.selectedChangeSku = action.payload;
        },
    },
});

export const { updateWarningsModal } = warningsModalSlice.actions;
export const { updateCustomModal } = customModalSlice.actions;
export const { updateBulkActionModal } = bulkActionModalSlice.actions;
export const { updateAddToExactModalDisp } = addToExactModalDispSlice.actions;
export const { updateCreateCampaignModal } = createCampaignModalSlice.actions;
export const { updateActionModal } = actionModalSlice.actions;
export const { updateTrendsModal } = trendsModalSlice.actions;
export const { updateCustomModalTitle } = customModalTitleSlice.actions;
export const { updateProductModalType } = productModalTypeSlice.actions;
export const { updateKeywordModalType } = keywordModalTypeSlice.actions;
export const { updateTrendsTitle } = trendsTitleSlice.actions;
export const { updateTrendsDataOne } = trendsDataOneSlice.actions;
export const { updateTrendsDataTwo } = trendsDataTwoSlice.actions;
export const { updateAsinId } = asinIdSlice.actions;
export const { updateKeywords } = keywordsSlice.actions;
export const { updateSmartKeywords } = smartKeywordsSlice.actions;
export const { updateSearchTermCampaigns } = searchTermCampaignsSlice.actions;
export const { updateSubmoduleElement } = submoduleElementSlice.actions;
export const { updateModuleAction } = moduleActionSlice.actions;
export const { updateIsEdit } = isEditSlice.actions;
export const { updateIsDaypartingEdit } = isDaypartingEditSlice.actions;
export const { updateDaypartingDataObject } = daypartingDataObjectSlice.actions;
export const { updateDaypartingCardCheckedData } =
    daypartingCardCheckedDataSlice.actions;
export const { updateDaypartingEditCampaignData } =
    daypartingEditCampaignDataSlice.actions;
export const { updateIsAllPortfoliosSelected } =
    isAllPortfoliosSelectedSlice.actions;
export const { updateIsAllCampaignsSelected } =
    isAllCampaignsSelectedSlice.actions;
export const { updateIsAllAdgroupsSelected } =
    isAllAdgroupsSelectedSlice.actions;
export const { updateDayPartingDisplay } = dayPartingDisplaySlice.actions;
export const { updateRule } = ruleSlice.actions;
export const { updateRulesApi } = rulesApiSlice.actions;
export const { updateIsSessionExpired } = isSessionExpiredSlice.actions;
export const { updateBulkTaxonomyDisplay } = bulkTaxonomyDisplaySlice.actions;
export const { updateShowAdminSettingsDisplay } =
    showAdminSettingsDisplaySlice.actions;
export const { updateShowCreateKeywordsReviewDisplay } =
    showCreateKeywordsReviewDisplaySlice.actions;
export const { updateShowRequestAlert } = showRequestAlertSlice.actions;
export const { updateOverwriteRequest } = overwriteRequestSlice.actions;
export const { updateBidOrBudgetModalDisplay } = updateBidOrBudgetModalSlice.actions;
export const { updateDailyBudgetModalDisplay } = dailyBudgetModalDisplaySlice.actions;
export const { updateBulkPlacementModalDisplay } = bulkPlacementModalDisplaySlice.actions;
export const { updateDailyBudgetModalData } = dailyBudgetModalDataSlice.actions;
export const { updateDailyBudgetReviewModalDisplay } =
    dailyBudgetReviewModalDisplaySlice.actions;
export const { updateDailyBudgetUpdatePayload } =
    dailyBudgetUpdatePayloadeSlice.actions;
export const { setAddAsExactData } =
    addAsExactDataSlice.actions;
export const { setcampaignPortfolioData } =
    campaignPortfolioDataSlice.actions;
export const { setIsSearchTermExact } =
    isSearchTermExactSlice.actions;
export const { updateAddToAdgroupModalDisplay, updateAddToAdgroupModalData } = addToAdgroupModalDataSlice.actions;
export const { updateCampaignConfigModalDisplay } =
    campaignConfigModalDisplaySlice.actions;
export const { updateIsCampaignStateAction } = isCampaignStateActionSlice.actions;
export const { updateCampaignStateActionResponse } = campaignStateActionResponseSlice.actions;
export const { updateCpmModalDisplay } =
    cpmModalDisplaySlice.actions;
export const { updateAddGoalsModalDisplay } =
    addGoalsModalDisplaySlice.actions;
export const { setGoalDataValues } =
    goalDataValuesSlice.actions;
export const { setGoalEditConfig } =
    goalEditConfigSlice.actions;
export const { setGoalModalTitle } =
    goalModalTitleSlice.actions;
export const { setIsGoalFormSubmitted } = isGoalFormSubmittedSlice.actions;
export const { setGoalListStatusType } = goalListStatusTypeSlice.actions;
export const { updateDeepDiveModalDisplay } =
    deepDiveModalSlice.actions;
export const { setAddBulkTagsModalDisplay } = addBulkTagsModalDisplaySlice.actions;
export const { setBulkProductMappingModalDisplay } = bulkProductMappingModalDisplaySlice.actions;
export const { updateBiddingModalDisplay, updateBiddingModalData } = biddingModalSlice.actions;
export const { setIsRuleSaveButtonDisabled } = isRuleSaveButtonDisabledSlice.actions
export const { updateAddMediaPlanModalDisplay } = addMediaPlanModalDisplaySlice.actions;
export const { updateShowNewMediaPlanDisplay } = showNewMediaPlanDisplaySlice.actions;
export const { setMediaPlanConfigValues } = mediaPlanConfigValuesSlice.actions;
export const { updateIsAllPfmDataSelected } = isAllPfmDataSelectedSlice.actions;
export const { updateProductMappingFilterModel } = productMappingFilterModelSlice.actions;
export const { updateKeywordMappingFilterModel } = keywordMappingFilterModelSlice.actions;
export const { updateBulkPfmMappingCount } = bulkPfmMappingCountSlice.actions;
export const { updateBulkKeywordMappingCount } = bulkKeywordMappingCountSlice.actions;
export const { updateApply1DsMappingModalDisplay } = apply1DsMappingModalDisplaySlice.actions;
export const { updateApply1DsKeywordMappingModalDisplay } = apply1DsKeywordMappingModalDisplaySlice.actions;
export const { updateConfirmModalDisplay } = confirmModalDisplaySlice.actions;
export const { updateDrilldownState, updateTrendsState, updateChangeSkuState, updateSelectedChangeSku } = showRevstackPopupSlice.actions;
export const { setBulkKeywordMappingModalDisplay } = bulkKeywordMappingModalSlice.actions;

export const bulkKeywordMappingModalDisplayReducer = bulkKeywordMappingModalSlice.reducer;
export const warningsModalReducer = warningsModalSlice.reducer;
export const customModalReducer = customModalSlice.reducer;
export const bulkActionModalReducer = bulkActionModalSlice.reducer;
export const bulkKeywordMappingModalReducer = bulkKeywordMappingModalSlice.reducer;
export const addToExactModalDispReducer = addToExactModalDispSlice.reducer;
export const createCampaignModalReducer = createCampaignModalSlice.reducer;
export const actionModalReducer = actionModalSlice.reducer;
export const trendsModalReducer = trendsModalSlice.reducer;
export const customModalTitleReducer = customModalTitleSlice.reducer;
export const productModalTypeReducer = productModalTypeSlice.reducer;
export const keywordModalTypeReducer = keywordModalTypeSlice.reducer;
export const trendsTitleReducer = trendsTitleSlice.reducer;
export const trendsDataOneReducer = trendsDataOneSlice.reducer;
export const trendsDataTwoReducer = trendsDataTwoSlice.reducer;
export const asinIdReducer = asinIdSlice.reducer;
export const keywordsReducer = keywordsSlice.reducer;
export const smartKeywordsReducer = smartKeywordsSlice.reducer;
export const searchTermCampaignsReducer = searchTermCampaignsSlice.reducer;
export const submoduleElementReducer = submoduleElementSlice.reducer;
export const moduleActionReducer = moduleActionSlice.reducer;
export const isEditReducer = isEditSlice.reducer;
export const isDaypartingEditReducer = isDaypartingEditSlice.reducer;
export const isAllPortfoliosSelectedReducer =
    isAllPortfoliosSelectedSlice.reducer;
export const isAllPfmDataSelectedSliceReducer = isAllPfmDataSelectedSlice.reducer;
export const isAllCampaignsSelectedReducer =
    isAllCampaignsSelectedSlice.reducer;
export const isAllAdgroupsSelectedReducer = isAllAdgroupsSelectedSlice.reducer;
export const isAllPfmDataSelectedReducer = isAllPfmDataSelectedSlice.reducer;
export const daypartingDataObjectReducer = daypartingDataObjectSlice.reducer;
export const daypartingCardCheckedDataReducer =
    daypartingCardCheckedDataSlice.reducer;
export const daypartingEditCampaignDataReducer =
    daypartingEditCampaignDataSlice.reducer;
export const ruleReducer = ruleSlice.reducer;
export const rulesApiReducer = rulesApiSlice.reducer;
export const isSessionExpiredReducer = isSessionExpiredSlice.reducer;
export const bulkTaxonomyDisplayReducer = bulkTaxonomyDisplaySlice.reducer;
export const showAdminSettingsDisplayReducer =
    showAdminSettingsDisplaySlice.reducer;
export const showCreateKeywordsReviewDisplayReducer =
    showCreateKeywordsReviewDisplaySlice.reducer;
export const dayPartingDisplayReducer = dayPartingDisplaySlice.reducer;
export const showRequestAlertReducer = showRequestAlertSlice.reducer;
export const overwriteRequestReducer = overwriteRequestSlice.reducer;
export const updateBidOrBudgetModalDisplayReducer = updateBidOrBudgetModalSlice.reducer;
export const dailyBudgetModalDisplayReducer = dailyBudgetModalDisplaySlice.reducer;
export const bulkPlacementModalDisplayReducer = bulkPlacementModalDisplaySlice.reducer;
export const dailyBudgetModalDataReducer = dailyBudgetModalDataSlice.reducer;
export const dailyBudgetReviewModalDisplayReducer = dailyBudgetReviewModalDisplaySlice.reducer;
export const dailyBudgetUpdatePayloadReducer = dailyBudgetUpdatePayloadeSlice.reducer;
export const dailyBudgetUpdateResponseReducer = dailyBudgetUpdateResponseSlice.reducer;
export const addAsExactDataReducer = addAsExactDataSlice.reducer;
export const campaignPortfolioDataReducer = campaignPortfolioDataSlice.reducer;
export const isSearchTermExactReducer = isSearchTermExactSlice.reducer;
export const addToAdgroupModalDataReducer = addToAdgroupModalDataSlice.reducer;
export const dateChangeModalDisplayReducer = campaignConfigModalDisplaySlice.reducer;
export const cpmModalDisplayReducer = cpmModalDisplaySlice.reducer;
export const isCampaignStateActionReducer = isCampaignStateActionSlice.reducer;
export const campaignStateActionResponseReducer = campaignStateActionResponseSlice.reducer;
export const addGoalsModalDisplayReducer = addGoalsModalDisplaySlice.reducer;
export const goalDataValuesReducer = goalDataValuesSlice.reducer;
export const goalEditConfigReducer = goalEditConfigSlice.reducer;
export const goalModalTitleReducer = goalModalTitleSlice.reducer;
export const isGoalFormSubmittedReducer = isGoalFormSubmittedSlice.reducer;
export const goalListStatusTypeReducer = goalListStatusTypeSlice.reducer;
export const deepDiveModalDisplayReducer = deepDiveModalSlice.reducer;
export const addBulkTagsModalDisplayReducer = addBulkTagsModalDisplaySlice.reducer;
export const bulkProductMappingModalDisplayReducer = bulkProductMappingModalDisplaySlice.reducer;
export const biddingModalReducer = biddingModalSlice.reducer;
export const isRuleSaveButtonDisabledReducer = isRuleSaveButtonDisabledSlice.reducer;
export const addMediaPlanModalDisplayReducer = addMediaPlanModalDisplaySlice.reducer;
export const showNewMediaPlanDisplayReducer = showNewMediaPlanDisplaySlice.reducer;
export const mediaPlanConfigValuesReducer = mediaPlanConfigValuesSlice.reducer;
export const productMappingFilterModelReducer = productMappingFilterModelSlice.reducer;
export const keywordMappingFilterModelReducer = keywordMappingFilterModelSlice.reducer;
export const bulkPfmMappingCountReducer = bulkPfmMappingCountSlice.reducer;
export const bulkKeywordMappingCountReducer = bulkKeywordMappingCountSlice.reducer;
export const apply1DsMappingModalDisplayReducer = apply1DsMappingModalDisplaySlice.reducer;
export const apply1DsKeywordMappingModalDisplayReducer = apply1DsKeywordMappingModalDisplaySlice.reducer;
export const confirmModalReducer = confirmModalDisplaySlice.reducer;
export const showRevstackPopupReducer = showRevstackPopupSlice.reducer;